import * as api from '@/services/course';

export default {
  namespace: 'course',
  state: {
  },
  effects: {
    *getSubjectLessonPage({ payload }: any, { call }: any): any {
      const res = yield call(api.getSubjectLessonPage, payload);

      const {
        records = [],
        current = 1,
        size = 10,
        total = 0,
      } = res.data || {};

      // ProTable 的 request 属性，需要返回特定数据结构的 Promise 对象
      return {
        data: records,
        total,
        success: true,
        page: current,
        pageSize: size,
      };
    },

    *getBookingRemark({ payload }: any, { call }: any): any {
      return yield call(api.getBookingRemark, payload);
    },

    *getSubjectLessonFeedBack({ payload }: any, { call }: any): any {
      return yield call(api.getSubjectLessonFeedBack, payload);
    },

    *submitSubjectLessonFeedBack({ payload }: any, { call }: any): any {
      return yield call(api.submitSubjectLessonFeedBack, payload);
    },
  },
  reducers: {
    _setState(state: any, { payload }: any) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};